export default __webpack_public_path__ + "static/media/Moon_Wasp_Logo.38b073fe.svg";